const hideBanner = sessionStorage.getItem('hide_banner');
if (hideBanner) document.getElementsByTagName('html')[0].classList.add('hide-banner');
